module.exports = __webpack_public_path__ + "static/media/ArtGalleryDesigner.b119431a.jpg";